module.exports = __webpack_public_path__ + "static/media/eye.9240aab1.svg";